/*dateRangeSafari mixin*/
import moment from 'moment';

export const dateRangeSafari = {
  computed: {
    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
  },
  methods: {
    prepareLastDate(period) {
       if (!this.isChanged) {
         return period;
       }

       if (this.isSafari) {
         period[1] = moment(period[1]).subtract(1,'d').format(this.format);
         return period;
       }
      return period;
    },
  },
};
